module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "title"
  }, [_vm._v("Work Jobs " + _vm._s(_vm.pagination ? "(" + _vm.pagination.totalItems + ")" : "") + "\n          ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue-grey",
    attrs: {
      "fab": "",
      "small": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.rightDrawer = !_vm.rightDrawer
      }
    }
  }, [_c('v-icon', [_vm._v("search")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "brown lighten-1",
    attrs: {
      "fab": "",
      "small": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.reloadData()
      }
    }
  }, [_c('v-icon', [_vm._v("refresh")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "teal darken-2",
    attrs: {
      "fab": "",
      "small": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.print()
      }
    }
  }, [_c('v-icon', [_vm._v("print")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "deep-orange darken-3",
    attrs: {
      "fab": "",
      "small": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.add($event)
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1), _vm._v(" "), (_vm.loading === false) ? _c('Table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.items,
      "pagination": _vm.pagination
    },
    on: {
      "edit": _vm.edit
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('search-panel', {
    attrs: {
      "rightDrawer": _vm.rightDrawer
    },
    on: {
      "cancelSearch": _vm.cancelSearch,
      "searchData": _vm.searchOrders
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "offset-xs1": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "id",
      "label": "Work Job",
      "light": ""
    },
    model: {
      value: (_vm.searchVm.equals.jobid),
      callback: function($$v) {
        _vm.$set(_vm.searchVm.equals, "jobid", $$v)
      },
      expression: "searchVm.equals.jobid"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "custphone",
      "label": "Customer Phone",
      "light": ""
    },
    model: {
      value: (_vm.searchVm.equals.custphone),
      callback: function($$v) {
        _vm.$set(_vm.searchVm.equals, "custphone", $$v)
      },
      expression: "searchVm.equals.custphone"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "serialnumber",
      "label": "Serial Number",
      "light": ""
    },
    model: {
      value: (_vm.searchVm.equals.deviceid),
      callback: function($$v) {
        _vm.$set(_vm.searchVm.equals, "deviceid", $$v)
      },
      expression: "searchVm.equals.deviceid"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "status",
      "items": _vm.statuss,
      "label": "Status",
      "light": ""
    },
    model: {
      value: (_vm.searchVm.equals.status),
      callback: function($$v) {
        _vm.$set(_vm.searchVm.equals, "status", $$v)
      },
      expression: "searchVm.equals.status"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "techid",
      "items": _vm.techs,
      "item-text": "techname",
      "item-value": "techid",
      "label": "Technician",
      "light": ""
    },
    model: {
      value: (_vm.searchVm.equals.techid),
      callback: function($$v) {
        _vm.$set(_vm.searchVm.equals, "techid", $$v)
      },
      expression: "searchVm.equals.techid"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.loading === false) ? _c('v-snackbar', {
    attrs: {
      "right": true,
      "timeout": _vm.timeout,
      "color": _vm.mode
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.notice) + "\n    "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeSnackbar($event)
      }
    }
  }, [_vm._v("Close")])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e326afb","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/OrderList.vue
// module id = 407
// module chunks = 1